import template from './vd-expandable-chevron.html'

const vdExpandableChevron = {
  template,
}

export default vdExpandableChevron
